import { cn } from '@/lib/utils';
import type { DdqSession } from '@/types/api.types';

export interface SessionStatusBadgeProps {
  status: DdqSession['status'];
  className?: string;
}

const STATUS_CONFIG = {
  Pending: {
    label: 'Pending',
    color: 'bg-gray-100 text-gray-700 border-gray-300',
    dot: 'bg-gray-400',
    animate: false,
  },
  Processing: {
    label: 'Processing',
    color: 'bg-blue-100 text-blue-700 border-blue-300',
    dot: 'bg-blue-500',
    animate: true,
  },
  Ready: {
    label: 'Ready',
    color: 'bg-green-100 text-green-700 border-green-300',
    dot: 'bg-green-500',
    animate: false,
  },
  Error: {
    label: 'Error',
    color: 'bg-red-100 text-red-700 border-red-300',
    dot: 'bg-red-500',
    animate: false,
  },
} as const;

export function SessionStatusBadge({ status, className }: SessionStatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border',
        config.color,
        className
      )}
    >
      <span
        className={cn(
          'w-2 h-2 rounded-full',
          config.dot,
          config.animate && 'animate-pulse'
        )}
      />
      {config.label}
    </span>
  );
}
